<template>
    <div class="loginverify_wrap">
        <van-nav-bar
                title=""
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div class="loginverify_top">
            <div class="loginverify_title">Ingresa OTP recibido desde SMS</div>
            <div class="loginverify_mobile">
                {{lookmobile}}
            </div>
        </div>

        <div class="loginverify_middle">
            <div class="loginverify_motp">Ingresa OTP de 4 digitos</div>

            <div class="loginverify_mcode">
                <div class="prize_other_dvview">
                    <div class="prize_other_inps">
                        <div class="youxi_form_wrap">
                            <!-- inputBoxview -->
                            <div class="inputBox">
                                <div v-for="(item, index) in captchas" :key="index"
                                     :class="fouceIndex == index ? 'scale-1px-fouce' : 'scale-1px'">
                                    <input
                                            v-model="item.num"
                                            :id="'captcha' + index"
                                            @input="inputFinish(index)"
                                            @focus="adjust(index)"
                                            @keydown="inputDirection(index, $event)"
                                            class="auth-b"
                                            type="tel"
                                            maxlength="1"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
            <div class="loginverify_mdesc" v-if="verifyCode">Código de verificación incorrecto</div>
            <div class="loginverify_msend" @click="verificationCode">
                <span :class="!isSendcode ? 'active' : '' ">Volver a enviar OTP</span> <template v-if="isSendcode">（{{codeval}}）</template>
            </div>
            <div class="loginverify_msend_view" v-if="isSendcode">
                <div class="loginverify_msend_mask" @click="onSmscodeEnd"></div>
            </div>

        </div>

        <div class="loginverify_footer" >
            <van-button round color="#19A95C" block style="height: 1.222222rem;" @click="createFingerprintLogin">
                <span style="font-weight: 500;">ENVIAR OTP</span>
            </van-button>
            <div style="width: 100%; height: 10px;"></div>
            <div class="loginverify_password" @click="goPassword">
                <span>No recibi el OTP</span>
            </div>
        </div>
    </div>
</template>

<script>

    import { Toast, Dialog } from 'vant';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { setAccessToken, getAccessToken } from '@/utils/auth'

    import FingerprintJS from '@fingerprintjs/fingerprintjs';

    import { openEventReport } from '@/api/user'

    import { getTimezoneName, getUserIp } from '@/utils/commonParams'
    import { getSmscode, loginsms } from '@/api/login'
    import { getLoanInfo } from '@/api/loan';


    let clock = null;

    export default{
        data() {
            return {
                fouceIndex: null,
                captchas: [{ num: "" }, { num: "" }, { num: "" }, { num: "" }],
                captchaCode: '',
                mobile: null,
                mobile_exist: false,
                lookmobile: null,
                nums: 60,
                isSendcode: false,
                codeval: '',
                verifyCode: false,
                orderStatusNor: null,
            }
        },
        created() {
            var userAgent = navigator.userAgent;
            console.log(userAgent);

            if (window.requestIdleCallback) {
                requestIdleCallback(() => {
                    this.createFingerprint(userAgent);
                });
            } else {
                setTimeout(() => {
                    this.createFingerprint(userAgent);
                }, 500);
            }
        },
        mounted() {
            let mobile = this.getQueryString('mobile');
            let mobile_exist = this.getQueryString('mobile_exist');
            let password_exist = this.getQueryString('password_exist');
            console.log(mobile)
            console.log(mobile_exist)
            console.log(password_exist)

            this.mobile_exist = mobile_exist;

            let lookmobile = '+52' + mobile.substring(0, 3)+"****"+mobile.substr(mobile.length-4);

            this.mobile = mobile;
            this.lookmobile = lookmobile;

            let isSendcode = window.localStorage.getItem('isSendcode');

            if(!isSendcode){
                window.localStorage.setItem('isSendcode', true);
            }

            if(!localStorage.getItem("adjust_id")){
                setTimeout(async () => {
                    await this.$adjust.waitForAttribution().then((attr) => {
                            localStorage.setItem("adjust_id", attr.adid)
                    });
                }, 10);
            }
        },
        methods: {
            createFingerprint(userAgent){
                let fbclid = '';

                if(this.getQueryString('fbclid')){
                    fbclid = this.getQueryString('fbclid')
                }

                FingerprintJS.load().then(fp => {
                    fp.get().then(result => {
                        console.log(result.visitorId);
                        //localStorage.setItem('browserId', result.visitorId);
                        if (!localStorage.getItem("adjust_id")) {
                            setTimeout(async () => {
                                await this.$adjust.waitForAttribution().then((attr) => {
                                    localStorage.setItem("adjust_id", attr.adid)
                                    let deviceType = this.checkDevice();
                                    this.openEventReport(attr.adid, fbclid, result.visitorId, deviceType, userAgent);
                                });
                            }, 10);
                        } else {
                            let deviceType = this.checkDevice();
                            let adjustId = localStorage.getItem("adjust_id");
                            this.openEventReport(adjustId, fbclid, result.visitorId, deviceType, userAgent);
                        }
                    });
                });
            },
            createFingerprintLogin() {
                if (window.requestIdleCallback) {
                    requestIdleCallback(() => {
                        FingerprintJS.load().then(fp => {
                            fp.get().then(result => {
                                console.log(result.visitorId);
                                this.goLogin(result.visitorId)
                            });
                        });
                    });
                } else {
                    setTimeout(() => {
                        FingerprintJS.load().then(fp => {
                            fp.get().then(result => {
                                console.log(result.visitorId);
                                this.goLogin(result.visitorId)
                            });
                        });
                    }, 500);
                }
            },
            checkDevice() {
                let device_type = 'PC';
                const ua = navigator.userAgent;
                if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                    device_type = 'iPhone'
                } else if (/Android/.test(ua)) {
                    device_type = 'Android'
                }

                return device_type;
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    //console.log(column.property)
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                if(sums[4] != 'N/A' && sums[5] != 'N/A'){
                    sums[10] = sums[5]/sums[4] * 100 + '%';
                }

                return sums;
            },
            onClickLeft() {
                //this.$router.back();
                this.$router.replace({
                    path: '/home'
                })
            },
            onClickRight() {

            },
            goPassword() {
                let usemobile = this.mobile
                this.$router.push({
                    path: '/loanpage/loginpassword',
                    query: {
                        mobile: usemobile
                    }
                })
            },
            async openEventReport(adjustId, facebook_id, finger_code, deviceType, userAgent){
                console.log('上报接口请求')
                let time_zone = getTimezoneName();
                console.log(time_zone);
                loadingShow();
                let ip = await getUserIp()
                console.log(ip)

                let postData = {
                    fa_bo_id: facebook_id,
                    fi_ng_er: finger_code,
                    us_eve_na: 'jg_open',
                };

                let headerParams = {
                    'ad-justad-id': adjustId,
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                    'us-de-ty': deviceType,
                    'us-age-en': userAgent
                };

                loadingShow();
                openEventReport(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    loadingHide()
                    this.isHomeLoading = false;
                    if(res.ci == 200){
                        console.log('上报成功')
                    } else {
                        Toast(res.ms)
                    }
                }, error => {
                    loadingHide();
                    this.isHomeLoading = false;
                })
            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            // 输入框聚焦
            adjust(index) {
                let _this = this;
                console.log(index)
                let dom = document.getElementById("captcha" + this.activeInput);
                if (index != this.activeInput && dom) {
                    dom.focus();
                }
                this.fouceIndex = index;
            },
            // 前后输入方向
            inputDirection(index, event) {
                let value = this.captchas[index].num;
                if (event.keyCode == 8 && value == "") {
                    let dom = document.getElementById("captcha" + (index - 1));
                    this.activeInput = index - 1;
                    if (dom) dom.focus();
                }
                if (event.keyCode != 8 && value != "") {
                    let dom = document.getElementById("captcha" + (index + 1));
                    this.activeInput = index + 1;
                    if (dom) dom.focus();
                }
            },
            // 输入框
            inputFinish(index) {
                let value = this.captchas[index].num;
                this.activeInput = value ? index + 1 : index - 1;
                let dom = document.getElementById("captcha" + this.activeInput);
                if (dom) dom.focus();
                if (index == this.captchas.length - 1) {
                    this.captchaCode = this.captchas.map((a) => a.num).join("");
                    if (this.captchaCode.length == 4) {
                        console.log("captchaCode", this.captchaCode);
                    }
                }
            },
            doLoop() {
                this.nums--;
                if(this.nums > 0){
                    this.codeval = this.nums + 's';
                } else {
                    clearInterval(clock);
                    clock = null;
                    this.isSendcode = false;
                    this.codeval = '';
                    this.nums = 60;
                    window.localStorage.setItem('isSendcode', false);
                }
            },
            commonparamsFun() {
                let commonparams = {
                    aaa_off_csl: '', //noise
                    zzm_yya_hqb: '', //access_token
                    //bac_fcc_gdc: '', //signature
                };

                return commonparams;
            },
            onSmscodeEnd() {
                Toast('Obtener el Código de verificación es demasiado frecuente, por favor espere!');
            },
            async verificationCode() {
                console.log('获取验证码')
                clearInterval(clock);
                clock = null;
                this.codeval = '';
                this.nums = 60;
                let _this = this;
                this.verifyCode = false;
                if(this.mobile){
                    //console.log(111111)
                    let getmobile = this.mobile;

                    let firstStr = getmobile.substr(0, 1);

                    let isflag = false;

                    if(firstStr == 1){ //1开始 11位
                        if(getmobile.length == 11){
                            isflag = true;
                        } else {
                            isflag = false;
                        }

                    } else {//非1 10位
                        if(getmobile.length == 10){
                            isflag = true;
                        } else {
                            isflag = false;
                        }
                    }

                    let commonparams = this.commonparamsFun();

                    if(isflag){
                        let usemobile = `+52${this.mobile}`;
                        let time_zone = getTimezoneName();
                        console.log(time_zone);
                        //let ip = await getUserIp()
                        let ip = '103.176.0.83';
                        console.log(ip)

                        let postData = {
                            iyc_kae_ixp: usemobile,
                            tdl_vpa_fvr: "8",
                            ...commonparams
                        };

                        let headerParams = {
                            'ad-justad-id': localStorage.getItem("adjust_id"),
                            'ad-justad-j': '',
                            'ad-justad-idfv': '',
                        };

                        loadingShow();

                        getSmscode(postData, {
                            'bwd-irh-lnf': time_zone,
                            'xfo-plp-van': ip,
                            ...headerParams
                        }).then(res => {
                            console.log(res)
                            loadingHide()
                            if(res.ci == 200){
                                this.isSendcode = true;
                                this.codeval = this.nums + 's';
                                clock = setInterval(_this.doLoop, 1000);
                                Toast('El Código de verificación fue enviado con éxito.')
                            } else {
                                Toast(res.ms)
                            }
                        }, error => {
                            loadingHide()
                        });
                    } else {
                        loadingHide()
                        Toast('Formato incorrecto del número móvil') //手机号码格式错误
                    }

                } else {
                    loadingHide()
                    Toast('Por favor ingrese el número de teléfono móvil') //请输入手机号
                }
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else {
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            async goLogin(finger_code) {
                let _this = this;
                this.verifyCode = false;
                if(this.captchaCode && this.captchaCode.length == 4){
                    let usemobile = `+52${this.mobile}`;

                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        iyc_kae_ixp: usemobile,
                        trf_nrw_gqf: this.captchaCode,
                        fi_ng_er: finger_code,
                        zzm_yya_hqb: '11',
                        vcb_jde_jwa: '111',
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    loginsms(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);

                                let { bqr_rle_jto, gev_wtw_dna, zzm_yya_hqb } = useDataJSON;

                                let access_token = zzm_yya_hqb;
                                setAccessToken(access_token);
                                this.$store.commit('common/SET_PRODUCT_ID', '');


                                this.gotoStatus();

                                // this.$router.replace({
                                //     path: '/loanpage/applyhome',
                                // })

                            }
                        } else {
                            loadingHide()
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        Toast('Falló el inicio de sesión, por favor vuelva a intentarlo')
                    });

                    /*setTimeout(() => {
                        loadingHide();

                        let res = {
                            "ci": 200,
                            "ms": "OK",
                            "da": "{\"gev_wtw_dna\":0,\"ijn_wts_cha\":51250618000000048,\"wva_cld_loe\":{\"ftp_kae_ccb\":{\"iyc_kae_ixp\":\"+5213011111111\"}},\"zzm_yya_hqb\":\"c40ad548353dedd4e64e03280e65e9df\",\"bqr_rle_jto\":9998,\"ojq_dzg_oxq\":1750244381779}"
                        };

                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);

                                let { bqr_rle_jto, gev_wtw_dna, zzm_yya_hqb } = useDataJSON;

                                let access_token = zzm_yya_hqb;
                                setAccessToken(access_token);

                                this.$router.replace({
                                    path: '/loanpage/applyhome',
                                })
                            }
                        }
                    }, 2000);*/

                    /*this.$router.replace({
                        path: '/loanpage/applyhome',
                    })*/
                } else {
                    console.log(this.captchaCode)
                    Toast('Por favor introduzca el captcha') //请输入验证码
                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });

                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
        }
    }
</script>

<style less scoped>
    .loginverify_wrap{
        width: 100%;
        height: auto;
    }
    .loginverify_top{
        width: 100%;
        height: 2.722222rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
    }
    .loginverify_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.444444rem;
        text-align: center;
    }
    .loginverify_mobile{
        width: 100%;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.388889rem;
        text-align: center;
        margin-top: 0.25rem;
    }
    .loginverify_middle{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
    }
    .loginverify_motp{
        width: 100%;
        height: 0.611111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 12px;
    }
    .loginverify_mcode{
        width: 100%;
        height: 1.222222rem;
    }
    .loginverify_mdesc{
        width: 100%;
        height: 0.916667rem;
        font-size: 13px;
        font-weight: 400;
        color: #FB4840;
        line-height: 0.916667rem;
    }
    .loginverify_msend{
        width: 100%;
        height: 1.0rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
    }
    .loginverify_msend .active{
        color: #333333;
    }
    .loginverify_msend_view{
        width: 100%;
        height: 1px;
        position: relative;
    }
    .loginverify_msend_mask{
        width: 100%;
        height: 1.1rem;
        position: absolute;
        left: 0;
        top: -1rem;
    }
    .loginverify_msend span{
        color: #999999;
        text-decoration: underline;
    }
    .loginverify_footer{
        width: 92.22%;
        height: auto;
        margin: 1.666667rem auto;
    }
    .prize_other_dvview{
        width: 100%;
        height: auto;
        margin: 0 auto;
    }
    .prize_other_inps{
        width: 100%;
    }
    .prize_oinps_view{
        width: 100%;
        height: 1.222222rem;
    }
    .prize_oinps_view input{
        display: block;
        width: 100%;
        height: 1.0rem;
        outline: none;
        background: #DEEEFF;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        padding-left: 0.266667rem;
        font-size: 0.373333rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #954F0A;
    }
    .youxi_form_wrap{
        width: 100%;
        height: 1.25rem;
    }
    .inputBox {
        width: 100%;
        height: 1.222222rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .auth-b {
        width: 1.888889rem;
        height: 1.111111rem;
        box-sizing: border-box;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        outline: none;
        line-height: 1.222222rem;
        text-align: center;
        font-size: 0.666667rem;
    }
    .inputBoxview{

    }
    .scale-1px{
        position: relative;
        border:none;
    }
    .scale-1px:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #C7C7C7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-fouce{
        position: relative;
        border:none;
    }
    .scale-1px-fouce:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #19A95C;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-error{
        position: relative;
        border:none;
    }
    .scale-1px-error:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #FB4840;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .inputBoxview .scale-1px:after{
        background: #FB4840;
    }
    .inputBoxview .scale-1px-fouce:after{
        background: #FB4840;
    }
    .loginverify_password{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loginverify_password span{
        font-size: 14px;
        color: #333333;
    }
</style>

<style less>
    .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>